import { render, staticRenderFns } from "./nav-header-alt.vue?vue&type=template&id=17d19028&scoped=true"
import script from "./nav-header-alt.vue?vue&type=script&lang=js"
export * from "./nav-header-alt.vue?vue&type=script&lang=js"
import style0 from "./nav-header-alt.vue?vue&type=style&index=0&id=17d19028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d19028",
  null
  
)

export default component.exports